import React from "react";

const ProductSamplePage = () => {
  return <div>ProductSamplePage</div>;
};

export default ProductSamplePage;
